'use strict';

import {EwSiteApp} from "../app/ewsiteapp.js";

EwSiteApp.factory('notify', ['$mdToast', '$sce', function($mdToast, $sce){
    const successMessageDelay = 10000;
    const toastPosition = 'top left';

    return function(message, isError, reload){
        const msg = angular.isArray(message) ? message.join(';\n') : message;
        const theme = isError ? 'error-toast' : 'success-toast';
        const hideDelay = isError ? 0 : successMessageDelay;

        const cfg = {
            hideDelay: hideDelay,
            position: toastPosition,
            toastClass: 'ew-notification ' + theme,
            controllerAs: 'vm',
            bindToController: true,
            locals: { msg: $sce.trustAsHtml(msg), theme: theme },
            controller: ['msg', 'theme', '$mdToast', function(msg, theme, $mdToast){
                this.msg = msg;
                this.theme = theme;
                this.close = function(){ $mdToast.hide(); };
            }],
            template:
                '<md-toast md-theme="{{::vm.theme}}">' +
                '<div class="md-toast-content" aria-live="polite" aria-relevant="all">' +
                '<span ng-bind-html="vm.msg"></span>' +
                '<md-button class="md-action md-icon-button" ng-click="vm.close()" aria-label="close">' +
                '<md-icon>close</md-icon>' +
                '</md-button>' +
                '</div>' +
                '</md-toast>'
        };

        const prom = $mdToast.show(cfg);
        if (reload === true) {
            prom.then(function(){ window.location.reload(true); }, function(){});
        }
    };
}]);
